import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";

import StatusCard from "components/cards/StatusCard";
import Fetch from "components/Fetch";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import DeleteButton from "components/buttons/DeleteButton";
import Loading from "components/App/Loading";
import ManageProductButton from "components/buttons/ManageProductButton";
import ManageGroupProduct from "components/Modals/ManageGroupProduct";
import Table from "components/Tables/Table";
import TableImage from "components/Tables/TableImage";
import Filters from "components/dashboard/Filters";
import { getState } from "state/selector";
import { GlassCard, CardsContainer } from "components/App/styled";
import { updateUser } from "state/actions";
// import CatalogView from "./Catalog";

function Index(props) {
  console.log("store redux", props.store);
  const [manageProductModal, setManageProductModal] = useState(false);
  const [data, setData] = useState(false);
  const [reload, setReload] = useState(false);
  const [products, setProducts] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);

  console.log("dashboard/index data", data);
  useEffect(() => {
    setProducts(false);
    setData(false);
    Fetch.get("/products", (res) => {
      if (res) {
        setProducts(res.products);
        setData(res);
        setReload(false);
      }
    });
    setReload(false);
  }, [reload]);
  function handleReload() {
    setReload(true);
  }
  function handleUpdate(index) {
    setUpdateModal(products[index]);
  }

  if (!data) {
    return <Loading />;
  }
  return (
    <div id="products-container">
      <CardsContainer>
        <StatusCard
          color={colors.secondary}
          textColor="#444"
          value={data.products.length}
          text="تعداد محصولات"
          link=""
        />
        <StatusCard
          color="#3A4041"
          textColor="#fff"
          value={data?.products_with_off}
          text="تخفیف های فعال"
          link="?is_off"
        />
        <StatusCard
          color="#E8E8E8"
          textColor="#444"
          value={
            data?.products?.filter((item) => Number(item.stock) === 0).length
          }
          text="کالا های بدون موجودی"
          link="?no_stock"
        />
      </CardsContainer>
      <GlassCard style={{ padding: "16px 4px" }}>
        <ManageProductButton
          reload={handleReload}
          data={data}
          visible={manageProductModal}
          setVisible={setManageProductModal}
        />
        <ManageProductButton
          reload={handleReload}
          data={data}
          oldData={updateModal}
          visible={updateModal ? true : false}
          setVisible={setUpdateModal}
          buttonStyle={{ display: "none" }}
        />
        <div>
          <ManageGroupProduct
            reload={handleReload}
            data={data}
            buttonStyle={{ margin: "12px 0 8px 8px" }}
            brands={data.brands}
            categories={data.sortedCategories}
          />
          {/* <CatalogView
            products={data.products}
            brands={data.brands}
            categories={data.categories}
          /> */}
        </div>

        <Filters data={data} products={products} setProducts={setProducts} />
      </GlassCard>

      <TableContainer>
        <Table
          loading={reload}
          columns={tableHeaders}
          size="small"
          dataSource={products.map((item, index) => ({
            ...item,
            price: item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            image: <TableImage data={JSON.parse(item.images)} />,
            actions: (
              <div className="row">
                <a
                  href={`https://epet.co/product/${item.id}`}
                  target="_blank"
                  style={{ marginLeft: 6 }}
                >
                  <Button>
                    <EyeOutlined />
                  </Button>
                </a>
                <Button onClick={() => handleUpdate(index)}>
                  <EditOutlined />
                </Button>
                <DeleteButton
                  id={item.id}
                  reload={setReload}
                  title="کالا"
                  link="products"
                />
              </div>
            ),
            key: index + 1,
          }))}
        />
      </TableContainer>
    </div>
  );
}
const mapStateToProps = (state) => {
  const store = getState(state);
  return { store };
};
export default connect(mapStateToProps, { updateUser })(Index);

const TableContainer = styled.div`
  margin-top: 48px;
  margin-bottom: 48px;
`;

const tableHeaders = [
  {
    title: "شمار",
    dataIndex: "key",
    key: "key",
    align: "center",
    width: "50px",
  },
  {
    title: "تصویر",
    dataIndex: "image",
    key: "image",
    align: "center",
    width: "54px",
  },
  {
    title: "نام کالا",
    dataIndex: "title",
    key: "title",
    align: "center",

    width: "100px",
    ellipsis: true,
  },
  {
    title: "دسته بندی",
    dataIndex: "category",
    key: "category",
    align: "center",
    width: "80px",
  },
  {
    title: "برند",
    dataIndex: "brand",
    key: "brand",
    align: "center",

    width: "80px",
  },
  {
    title: "موجودی",
    dataIndex: "stock",
    key: "stock",
    align: "center",
    width: "64px",
    sorter: (a, b) => a.stock - b.stock,
  },
  {
    title: "قیمت",
    dataIndex: "price",
    key: "price",
    align: "center",
    width: "80px",
  },
  {
    title: "اعمال",
    dataIndex: "actions",
    key: "actions",
    align: "center",
    width: "80px",
  },
  {
    title: "کد",
    dataIndex: "code",
    key: "code",
    align: "center",
    width: "40px",
  },
];
